<div *ngIf="component"
     [grid]="client.isM || client.isS ? 1 : 2"
     [style.columnGap.px]="40"
     [style.rowGap.px]="20"
     class="wrap-x">
    <div [ngClass]="component.ratio || 'ratio-1-1'"
         [style.order]="this.component.swapOrder ? 2 : 1">
        <img class="rf z-1"
             [image]="component.image">
        <ng-container *ngIf="component.videoId && component.variant === 'video'">
            <youtube-player class="z-2"
                            [video-id]="component.videoId"
                            [autoplay-in-viewport]="component.videoAutoplay"
                            [background]="component.videoBackgroundMode"
                            *ngIf="component.videoProvider === 'youtube'">
                <!-- play icon -->
                <ng-template #playButton>
                    <i class="icon-play"></i>
                </ng-template>

                <!-- pause icon -->
                <ng-template #pauseButton>
                    <i class="icon-pause"></i>
                </ng-template>
            </youtube-player>

            <vimeo-player class="z-2"
                          [video-id]="component.videoId"
                          [autoplay-in-viewport]="component.videoAutoplay"
                          [background]="component.videoBackgroundMode"
                          *ngIf="component.videoProvider === 'vimeo'">
                <!-- play icon -->
                <ng-template #playButton>
                    <i class="icon-play"></i>
                </ng-template>

                <!-- pause icon -->
                <ng-template #pauseButton>
                    <i class="icon-pause"></i>
                </ng-template>
            </vimeo-player>
        </ng-container>
    </div>
    <div class="flex flex-column flex-justify-center p-l-4-s p-l-4-m p-r-4-s p-r-4-m"
         [style.order]="this.component.swapOrder ? 1 : 2">
        <h5 class="h2"
            *iCms="'title' of component"></h5>
        <p class="p2 col-11 p-t"
           *iCms="'description' of component"></p>
    </div>
</div>